import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const STORAGE_KEY = 'fluo_lang';

const resources = {
  fr: {
    translation: {
      brand: { tagline: 'par SNCF Voyageurs • Tableau dynamique' },
      nav: { home: 'Accueil', board: 'Horaires par gare', commute: 'Mon trajet quotidien', info_fluo: "Toute l'info Fluo", lines: 'Lignes principales' },
      hero: {
        live_badge: 'Données temps réel • SNCF Open Data • Navitia',
        title_part1: "L'information en temps réel des",
        title_highlight: 'trains Fluo',
        title_part2: 'Grand Est.',
        subtitle: 'par SNCF Voyageurs',
        description: "Horaires et informations sur le trafic en temps réel, numéro de voie et composition de chaque train pour toutes les gares du Grand Est. Sélectionnez vos trajets favoris et créez vos propres tableaux.",
        feature_realtime: 'Horaires temps réel',
        feature_platforms: 'Voies et quais',
        feature_route: 'Itinéraire complet',
        feature_composition: 'Composition du train'
      },
      mobility: {
        title: 'Fluo Grand Est, votre mobilité au quotidien !',
        text: "Fluo rassemble l'ensemble des solutions de mobilité du Grand Est pour faciliter les déplacements du quotidien dans toute la région. Un réseau connecté, accessible et pensé pour répondre à tous !",
        stat_trains_prefix: 'près de',
        stat_trains: 'trains / jour',
        stat_buses: 'cars / jour',
        stat_stations: 'gares',
        stat_bikes: 'vélos',
        stat_bikes_sub: 'dans 52 gares',
        more: "Plus d'info",
      },
      lines: {
        eyebrow: 'Réseau Fluo Grand Est',
        title: 'Lignes principales',
        sublabel: 'Fluo Grand Est'
      },
      opendata: {
        eyebrow: 'Open Data',
        title: 'Construit avec les données ouvertes SNCF / Navitia',
        text: "Cette interface utilise les API publiques (Navitia, SIRI, GTFS-RT) pour fournir aux voyageurs un tableau dynamique clair. Les données restent indicatives — priorité à l'affichage en gare."
      },
      campaign: { sidebar_title: 'Communication Fluo' },
      picker: {
        placeholder: 'Sélectionnez une gare (Strasbourg, Metz, Nancy...)',
        button: 'Rechercher',
        no_match: 'Aucune gare ne correspond à « {{q}} »',
        empty: "Saisissez le nom d'une gare pour commencer",
        kbd_hint: '↑↓ naviguer • ⏎ sélectionner',
        navitia_search: 'Recherche Navitia',
        popular_count: '{{count}} gares Grand Est',
        popular_title: 'Gares populaires',
        favorites_title: 'Mes gares favorites',
        another_station: 'Choisir une autre gare'
      },
      board: {
        station_eyebrow: 'Gare de',
        favorite: 'Ajouter aux favoris',
        refresh: 'Actualiser',
        tab_dep: 'Départs',
        tab_arr: 'Arrivées',
        source_live: 'Source : SNCF Open Data • Navitia — temps réel',
        source_piv:  'Source : SNCF PIV — temps réel',
        source_demo: 'Source : Démo (mock)',
        loading: 'Chargement des données…',
        empty_dep: 'Aucun départ prévu pour cette gare.',
        empty_arr: 'Aucune arrivée prévue pour cette gare.',
        col_time: 'Heure',
        col_train: 'Train',
        col_destination: 'Destination',
        col_origin: 'Provenance',
        col_coaches: 'Voitures',
        col_seats: 'Places assises',
        col_platform: 'Numéro de voie',
        col_status: 'Statut',
        platform_label: 'Voie',
        status_ontime: "À l'heure",
        status_delayed: 'Retardé',
        status_cancelled: 'Supprimé',
        view_route: "voir l'itinéraire",
        see_detail: 'Détail',
        disclaimer: "Les horaires sont indicatifs et peuvent changer en temps réel. Consultez l'affichage en gare avant le départ.",
        demo_banner: 'Mode démo — données simulées.',
        reconnect_banner: 'Reconnexion à Navitia… (les dernières données restent affichées)'
      },
      search_dialog: {
        title: 'Rechercher une gare',
        text: "Sélectionnez une gare pour afficher ses départs et arrivées en temps réel."
      },
      train: {
        crumb: 'Détails du train',
        train_label: 'Train',
        vehicle_train: 'Train',
        vehicle_bus: 'Bus',
        tab_route: 'Itinéraire',
        tab_map: 'Carte',
        tab_composition: 'Composition',
        real_data_badge: 'DONNÉES RÉELLES',
        source_navitia: 'Source : Navitia / SNCF Open Data',
        stops_count: '{{count}} arrêts',
        loading_route: "Chargement de l'itinéraire…",
        no_stops: 'Aucun arrêt trouvé pour ce train.',
        comp_unavailable_title: 'Composition non disponible',
        comp_unavailable_text: "Le matériel roulant pour le train {{number}} n'est pas référencé dans notre base. Cette information n'est pas exposée par l'API publique SNCF — elle nécessite un accès au flux interne SNCF Voyageurs.",
        comp_disclaimer_title: 'Données indicatives',
        comp_disclaimer_text: "Le référentiel « Composition Théorique » du matériel roulant n'est pas exposé publiquement par SNCF Voyageurs. Les informations ci-dessous sont une représentation indicative (mock) en attendant un accès autorisé au flux interne.",
        coaches: 'Voitures',
        seats: 'Places assises',
        material: 'Matériel',
        configuration: 'Configuration',
        head_label: 'TÊTE',
        direction: 'SENS DE MARCHE',
        legend_pmr: 'Accès PMR',
        legend_bike: 'Vélos',
        legend_class: 'Classe',
        legend_occupancy: 'Affluence indicative',
        coach_num: 'N°{{n}}',
        map_sources: 'Sources : OpenStreetMap + Navitia (SNCF Open Data)',
        map_no_coords: "Coordonnées géographiques indisponibles pour ce train.",
        map_legend_endpoints: 'Origine / Terminus',
        map_legend_stops: '{{count}} arrêts intermédiaires',
        map_legend_status_on_time: 'Tracé à l\'heure',
        map_legend_status_delayed: 'Tracé retardé',
        map_legend_status_cancelled: 'Train supprimé',
        map_train_live: 'Position estimée',
        map_train_position: 'Position estimée du train',
        map_position_disclaimer: 'Interpolation linéaire entre deux arrêts (précision ±1 km). Non disponible pour les trains supprimés.',
        map_locate_me: 'Ma position',
        map_you_are_here: 'Vous êtes ici',
        map_geoloc_denied: 'Permission de géolocalisation refusée.',
        map_geoloc_failed: 'Impossible de récupérer votre position.',
        map_geoloc_unsupported: 'Géolocalisation non supportée par votre navigateur.',
        map_attribution: 'Fonds de carte : © OpenStreetMap contributors',
        coach_seats: '{{n}} pl.'
      },
      composition: {
        seats_unavailable: 'Information non disponible'
      },
      accessibility: {
        title:      'Accessibilité',
        standard:   'Affichage standard',
        dyslexia:   'Mode dyslexie',
        lowvision:  'Mode malvoyant',
        persist:    'Mémoriser mon choix',
      },
      footer: {
        text: "Tableau dynamique des trains Fluo Grand Est par SNCF Voyageurs. Information voyageurs en temps réel via les données ouvertes SNCF (Navitia, SIRI, GTFS-RT) : horaires, voies, perturbations.",
        nav_title: 'Navigation',
        admin_link: 'Espace Admin',
        legal_title: 'Légal',
        legal_terms: 'Mentions légales',
        legal_privacy: 'Politique de confidentialité',
        legal_cgu: 'CGU',
        copyright: '© {{year}} SNCF Voyageurs — Fluo Grand Est. Reproduction interdite, tous droits réservés.',
        sources: 'Données : SNCF Open Data • Navitia • GTFS-RT'
      },
      lang: { label: 'Langue' },
      share: {
        title: 'Partager / Prévenir',
        title_prefix: 'Info train Grand Est',
        whatsapp: 'Envoyer via WhatsApp',
        sms: 'Envoyer par SMS',
        copy: 'Copier le message',
        copied: 'Message copié dans le presse-papiers',
        copy_failed: 'Impossible de copier',
        notify_10: 'Me prévenir 10 min avant',
        notify_scheduled: 'Notification programmée dans {{mins}} min',
        notify_unsupported: 'Notifications non prises en charge par ce navigateur',
        notify_denied: 'Autorisation des notifications refusée',
        notify_too_late: "L'horaire est déjà passé ou trop proche (< 10 min)",
        dep_at: 'Départ à',
        arr_at: 'Arrivée à',
        arr_expected: 'Arrivée prévue',
        notif_body_dep: 'Départ {{time}} → {{dest}} (voie {{platform}})',
        notif_body_arr: 'Arrivée {{time}} à {{station}} depuis {{origin}} (voie {{platform}})'
      },
      commute: {
        eyebrow: 'Mon trajet quotidien',
        title: 'Renseignez votre trajet favori et enregistrez vos tableaux personnalisés',
        from: 'Départ',
        to: 'Arrivée',
        from_placeholder: 'Gare de départ',
        to_placeholder: 'Gare d\'arrivée',
        save: 'Enregistrer',
        swap: 'Inverser',
        edit: 'Modifier',
        delete: 'Effacer',
        next_n: '{{n}} prochains trains directs',
        empty: 'Aucun train direct trouvé pour ce trajet dans la prochaine heure.',
        seats_short: 'pl.',
        mode_label: 'Mode',
        mode_next: 'Prochains trains',
        mode_custom: 'Horaires personnalisés',
        from_time_label: 'À partir de',
        window_3h: '(plage de 3 h)',
        return_label: 'Retour',
        return_from_time: 'Retour à partir de',
        return_section: 'Retour',
        custom_window_title: 'à partir de {{time}} — plage 3 h',
        save_settings: 'Enregistrer les préférences',
        cookies_needed: 'Pour enregistrer votre trajet sur cet appareil, acceptez les cookies fonctionnels (bannière en bas de page ou « Gérer les cookies » dans le pied de page). Aucune donnée n\'est partagée avec des tiers.',
        count_label: '{{n}} trains'
      },
      wa_channel: {
        label: 'Plus d\'infos sur notre chaîne WhatsApp',
        tooltip: 'Ouvrir la chaîne WhatsApp Fluo Grand Est — informations en temps réel sur les retards Metz ↔ Thionville ↔ Luxembourg'
      },
      export: {
        pdf: 'Exporter PDF',
        generated_at: 'Édité le',
        section_outbound: 'Aller',
        section_return: 'Retour',
        footer_text: 'Tableau dynamique des trains Fluo Grand Est par SNCF Voyageurs. Information voyageurs en temps réel via les données ouvertes SNCF (Navitia, SIRI, GTFS-RT) : horaires, voies, perturbations.',
        footer_copyright: '© 2026 SNCF Voyageurs — Fluo Grand Est. Tous droits réservés.'
      },
      tableau: {
        empty_title: 'Choisissez une gare pour afficher le tableau',
        empty_text: 'Saisissez le nom d\'une gare ou sélectionnez-la dans la liste pour consulter les départs et arrivées en temps réel.'
      },
      cookies: {
        title: 'Préférences de navigation',
        intro_v2: 'Fluo Grand Est utilise des cookies et le stockage local de votre navigateur. Vous pouvez activer chaque catégorie séparément. Aucun cookie publicitaire.',
        cat_necessary: 'Strictement nécessaires',
        cat_necessary_desc: 'Indispensables au fonctionnement du site (mémorisation de votre choix de consentement, langue d\'interface). Ne peuvent pas être désactivés.',
        cat_preferences: 'Préférences',
        cat_preferences_desc: 'Mémorisation de vos gares favorites et de votre trajet quotidien sur cet appareil. Aucune donnée envoyée à un tiers.',
        cat_analytics: 'Mesure d\'audience',
        cat_analytics_desc: 'Statistiques anonymes d\'usage via PostHog pour améliorer l\'application. Aucune publicité, aucune revente de données.',
        no_tracking_v2: 'Vous pouvez modifier vos choix à tout moment via « Gérer les cookies » en pied de page. Refuser n\'a aucun impact sur la consultation des horaires.',
        accept_all: 'Tout accepter',
        refuse_all: 'Tout refuser',
        save_choices: 'Enregistrer mes choix',
        manage: 'Gérer les cookies',
      },
      disruptions: {
        banner_title_one: '1 train retardé ou supprimé',
        banner_title_other: '{{count}} trains retardés ou supprimés',
        banner_title: '{{count}} train(s) retardé(s) ou supprimé(s)',
        major: 'majeure',
        minor: 'mineure',
        unknown_label: 'Perturbation',
        row_tooltip: 'Ce train est concerné par une perturbation',
        effect: {
          no_service:           'Suppression',
          significant_delays:   'Train retardé',
          reduced_service:      'Service réduit',
          detour:               'Déviation',
          modified_service:     'Service modifié',
          additional_service:   'Train supplémentaire',
          stop_moved:           'Arrêt déplacé',
          other_effect:         'Information voyageur',
          unknown:              'Perturbation'
        }
      },
      legal: {
        back: "Retour à l'accueil",
        updated: 'Dernière mise à jour : mai 2026',
        ml_title: 'Mentions légales',
        ml_editor_title: 'Éditeur',
        ml_editor_body: "InfoTrainFluo est un outil d'information voyageurs développé par Alterdia pour le compte de SNCF Voyageurs — Fluo Grand Est.\n\nSNCF Voyageurs — 2, place aux Étoiles — CS 70001 — 93633 La Plaine Saint-Denis Cedex\nSociété anonyme au capital de 100 000 000 €\nSIREN : 412 280 737 — RCS Bobigny",
        ml_host_title: 'Hébergement',
        ml_host_body: 'OVH SAS — 2 rue Kellermann — 59100 Roubaix — France\nSAS au capital de 10 000 000 € — RCS Lille Métropole 424 761 419',
        ml_data_title: 'Données utilisées',
        ml_data_body: "Les données horaires et de trafic sont issues des API publiques SNCF (Navitia, GTFS-RT, SIRI) accessibles via SNCF Open Data (opendata.sncf.com). Ces données sont indicatives et ne sauraient engager la responsabilité de l'éditeur en cas d'inexactitude.",
        ml_liability_title: 'Responsabilité',
        ml_liability_body: "L'éditeur s'efforce d'assurer l'exactitude des informations diffusées mais ne peut garantir leur exhaustivité ni leur mise à jour en temps réel. En cas de doute, l'affichage en gare fait foi.",
        pc_title: 'Politique de confidentialité',
        pc_intro: "InfoTrainFluo collecte un minimum de données personnelles, uniquement pour assurer le bon fonctionnement du service. Aucune donnée n'est vendue ni transmise à des tiers à des fins commerciales.",
        pc_cookies_title: 'Cookies et stockage local',
        pc_cookies_body: "• Cookies nécessaires : mémorisation du consentement et de la langue. Durée : 1 an.\n• Cookies de préférences : vos gares favorites et trajet quotidien, stockés localement sur votre appareil. Durée : 1 an. Désactivables via la bannière cookies.\n• Cookies analytiques (PostHog) : statistiques anonymes d'usage, sans identifiant personnel. Activés uniquement après consentement explicite.",
        pc_rights_title: 'Vos droits (RGPD)',
        pc_rights_body: "Conformément au Règlement Général sur la Protection des Données (UE 2016/679), vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition aux données vous concernant. Pour exercer ces droits, contactez-nous par e-mail.",
        pc_contact_title: 'Contact DPO',
        pc_contact_body: 'Pour toute question relative à la protection de vos données personnelles, adressez-vous au Délégué à la Protection des Données de SNCF Voyageurs : dpo@sncf.fr',
        cgu_title: "Conditions Générales d'Utilisation",
        cgu_object_title: 'Objet',
        cgu_object_body: "InfoTrainFluo est un outil d'information voyageurs à destination du grand public, proposant des horaires et informations de trafic en temps réel pour les trains Fluo Grand Est opérés par SNCF Voyageurs.",
        cgu_access_title: 'Accès au service',
        cgu_access_body: "L'accès au service est gratuit et ne nécessite pas de création de compte. L'utilisateur s'engage à utiliser le service conformément aux présentes CGU et à la législation en vigueur.",
        cgu_ip_title: 'Propriété intellectuelle',
        cgu_ip_body: "L'ensemble des éléments constituant ce site (textes, logos, marques, visuels) est protégé par le droit de la propriété intellectuelle. La marque SNCF, le logo Fluo et les visuels associés sont la propriété exclusive de SNCF Voyageurs. Toute reproduction est interdite sans autorisation préalable.",
        cgu_liability_title: 'Limitation de responsabilité',
        cgu_liability_body: "Les informations horaires sont fournies à titre indicatif via les données ouvertes SNCF. L'éditeur décline toute responsabilité en cas d'inexactitude, de retard dans la mise à jour ou d'interruption du service. L'affichage en gare reste la référence officielle."
      }
    }
  },
  en: {
    translation: {
      brand: { tagline: 'by SNCF Voyageurs • Live timetable' },
      nav: { home: 'Home', board: 'Station timetable', commute: 'My daily commute', info_fluo: 'All Fluo info', lines: 'Main lines' },
      hero: {
        live_badge: 'Real-time data • SNCF Open Data • Navitia',
        title_part1: 'Real-time information for',
        title_highlight: 'Fluo trains',
        title_part2: 'in Grand Est.',
        subtitle: 'by SNCF Voyageurs',
        description: 'Real-time schedules and traffic information, platform number and composition of every train for all stations in Grand Est. Pick your favourite journeys and build your own boards.',
        feature_realtime: 'Real-time schedules',
        feature_platforms: 'Tracks & platforms',
        feature_route: 'Full itinerary',
        feature_composition: 'Train composition'
      },
      mobility: {
        title: 'Fluo Grand Est, your everyday mobility!',
        text: 'Fluo brings together every mobility solution in Grand Est to make daily journeys easier across the whole region. A connected, accessible network designed for everyone!',
        stat_trains_prefix: 'nearly',
        stat_trains: 'trains / day',
        stat_buses: 'coaches / day',
        stat_stations: 'stations',
        stat_bikes: 'bicycles',
        stat_bikes_sub: 'in 52 stations',
        more: 'Learn more',
      },
      lines: { eyebrow: 'Fluo Grand Est network', title: 'Main lines', sublabel: 'Fluo Grand Est' },
      opendata: { eyebrow: 'Open Data', title: 'Built with SNCF / Navitia open data', text: 'This interface uses public APIs (Navitia, SIRI, GTFS-RT) to provide travellers with a clear live timetable. Data is indicative — always check station displays first.' },
      campaign: { sidebar_title: 'Fluo communication' },
      picker: {
        placeholder: 'Select a station (Strasbourg, Metz, Nancy...)',
        button: 'Search',
        no_match: 'No station matches « {{q}} »',
        empty: 'Type a station name to start',
        kbd_hint: '↑↓ navigate • ⏎ select',
        navitia_search: 'Navitia search',
        popular_count: '{{count}} Grand Est stations',
        popular_title: 'Popular stations',
        favorites_title: 'My favourite stations',
        another_station: 'Pick another station'
      },
      board: {
        station_eyebrow: 'Station',
        favorite: 'Add to favourites',
        refresh: 'Refresh',
        tab_dep: 'Departures',
        tab_arr: 'Arrivals',
        source_live: 'Source: SNCF Open Data • Navitia — live',
        source_piv:  'Source: SNCF PIV — real time',
        source_demo: 'Source: Demo (mock)',
        loading: 'Loading data…',
        empty_dep: 'No upcoming departures for this station.',
        empty_arr: 'No upcoming arrivals for this station.',
        col_time: 'Time',
        col_train: 'Train',
        col_destination: 'Destination',
        col_origin: 'Origin',
        col_coaches: 'Coaches',
        col_seats: 'Seats',
        col_platform: 'Platform number',
        col_status: 'Status',
        platform_label: 'Track',
        status_ontime: 'On time',
        status_delayed: 'Delayed',
        status_cancelled: 'Cancelled',
        view_route: 'view route',
        see_detail: 'Detail',
        disclaimer: 'Times are indicative and may change in real time. Check the station display before boarding.',
        demo_banner: 'Demo mode — simulated data.',
        reconnect_banner: 'Reconnecting to Navitia… (last data still displayed)'
      },
      search_dialog: { title: 'Search for a station', text: 'Select a station to view its real-time departures and arrivals.' },
      train: {
        crumb: 'Train details',
        train_label: 'Train',
        vehicle_train: 'Train',
        vehicle_bus: 'Bus',
        tab_route: 'Route',
        tab_map: 'Map',
        tab_composition: 'Composition',
        real_data_badge: 'LIVE DATA',
        source_navitia: 'Source: Navitia / SNCF Open Data',
        stops_count: '{{count}} stops',
        loading_route: 'Loading route…',
        no_stops: 'No stops found for this train.',
        comp_unavailable_title: 'Composition unavailable',
        comp_unavailable_text: "Rolling stock for train {{number}} is not in our database. This information is not exposed by the public SNCF API — it requires access to the internal SNCF Voyageurs feed.",
        comp_disclaimer_title: 'Indicative data',
        comp_disclaimer_text: 'The "Theoretical Composition" reference for rolling stock is not publicly exposed by SNCF Voyageurs. The information below is an indicative representation (mock) until authorised access to the internal feed is granted.',
        coaches: 'Coaches',
        seats: 'Seats',
        material: 'Rolling stock',
        configuration: 'Configuration',
        head_label: 'HEAD',
        direction: 'DIRECTION OF TRAVEL',
        legend_pmr: 'Wheelchair access',
        legend_bike: 'Bicycles',
        legend_class: 'Class',
        legend_occupancy: 'Indicative occupancy',
        coach_num: '#{{n}}',
        coach_seats: '{{n}} seats',
        map_sources: 'Sources: OpenStreetMap + Navitia (SNCF Open Data)',
        map_no_coords: 'Geographic coordinates not available for this train.',
        map_legend_endpoints: 'Origin / Terminus',
        map_legend_stops: '{{count}} intermediate stops',
        map_legend_status_on_time: 'On time',
        map_legend_status_delayed: 'Delayed',
        map_legend_status_cancelled: 'Cancelled',
        map_train_live: 'Estimated position',
        map_train_position: 'Estimated train position',
        map_position_disclaimer: 'Linear interpolation between two stops (accuracy ±1 km). Not available for cancelled trains.',
        map_locate_me: 'My location',
        map_you_are_here: 'You are here',
        map_geoloc_denied: 'Geolocation permission denied.',
        map_geoloc_failed: 'Unable to get your location.',
        map_geoloc_unsupported: 'Geolocation not supported by your browser.',
        map_attribution: 'Basemap: © OpenStreetMap contributors'
      },
      composition: {
        seats_unavailable: 'Information not available'
      },
      accessibility: {
        title:      'Accessibility',
        standard:   'Standard display',
        dyslexia:   'Dyslexia mode',
        lowvision:  'Low vision mode',
        persist:    'Remember my choice',
      },
      footer: {
        text: 'Live timetable of Fluo Grand Est trains by SNCF Voyageurs. Real-time traveller information via SNCF open data (Navitia, SIRI, GTFS-RT): schedules, platforms, disruptions.',
        nav_title: 'Navigation',
        admin_link: 'Admin area',
        legal_title: 'Legal',
        legal_terms: 'Legal notice',
        legal_privacy: 'Privacy policy',
        legal_cgu: 'Terms',
        copyright: '© {{year}} SNCF Voyageurs — Fluo Grand Est. Reproduction prohibited, all rights reserved.',
        sources: 'Data: SNCF Open Data • Navitia • GTFS-RT'
      },
      lang: { label: 'Language' },
      share: {
        title: 'Share / Notify',
        title_prefix: 'Grand Est train info',
        whatsapp: 'Send via WhatsApp',
        sms: 'Send via SMS',
        copy: 'Copy message',
        copied: 'Message copied to clipboard',
        copy_failed: 'Could not copy',
        notify_10: 'Remind me 10 min before',
        notify_scheduled: 'Reminder scheduled in {{mins}} min',
        notify_unsupported: 'Notifications not supported in this browser',
        notify_denied: 'Notification permission denied',
        notify_too_late: 'Time is already past or too close (< 10 min)',
        dep_at: 'Departure at',
        arr_at: 'Arrival at',
        arr_expected: 'Expected arrival',
        notif_body_dep: 'Departure {{time}} → {{dest}} (track {{platform}})',
        notif_body_arr: 'Arrival {{time}} at {{station}} from {{origin}} (track {{platform}})'
      },
      commute: {
        eyebrow: 'My daily commute',
        title: 'Save your favourite journey and build your own boards',
        from: 'From',
        to: 'To',
        from_placeholder: 'Departure station',
        to_placeholder: 'Arrival station',
        save: 'Save',
        swap: 'Swap',
        edit: 'Edit',
        delete: 'Clear',
        next_n: 'Next {{n}} direct trains',
        empty: 'No direct train found for this route within the next hour.',
        seats_short: 'seats',
        mode_label: 'Mode',
        mode_next: 'Next trains',
        mode_custom: 'Custom times',
        from_time_label: 'From',
        window_3h: '(3 h window)',
        return_label: 'Return',
        return_from_time: 'Return from',
        return_section: 'Return',
        custom_window_title: 'from {{time}} — 3 h window',
        save_settings: 'Save preferences',
        cookies_needed: 'To save your commute on this device, accept functional cookies (banner at the bottom of the page or "Manage cookies" in the footer). No data is shared with third parties.',
        count_label: '{{n}} trains'
      },
      wa_channel: {
        label: 'More info on our WhatsApp channel',
        tooltip: 'Open the Fluo Grand Est WhatsApp channel — live updates on Metz ↔ Thionville ↔ Luxembourg disruptions'
      },
      export: {
        pdf: 'Export PDF',
        generated_at: 'Generated on',
        section_outbound: 'Outbound',
        section_return: 'Return',
        footer_text: 'Live Fluo Grand Est train board by SNCF Voyageurs. Real-time traveller information via SNCF open data (Navitia, SIRI, GTFS-RT): schedules, platforms, disruptions.',
        footer_copyright: '© 2026 SNCF Voyageurs — Fluo Grand Est. All rights reserved.'
      },
      tableau: {
        empty_title: 'Pick a station to display the timetable',
        empty_text: 'Type a station name or select one from the list to view real-time departures and arrivals.'
      },
      cookies: {
        title: 'Browsing preferences',
        intro_v2: 'Fluo Grand Est uses cookies and your browser\'s local storage. You can enable each category individually. No advertising cookies.',
        cat_necessary: 'Strictly necessary',
        cat_necessary_desc: 'Required for the site to work (remembering your consent choice, UI language). Cannot be disabled.',
        cat_preferences: 'Preferences',
        cat_preferences_desc: 'Saves your favourite stations and daily commute on this device. No data is sent to a third party.',
        cat_analytics: 'Audience measurement',
        cat_analytics_desc: 'Anonymous usage statistics via PostHog to improve the application. No advertising, no data resale.',
        no_tracking_v2: 'You can change your choices at any time via "Manage cookies" in the footer. Refusing has no impact on timetable access.',
        accept_all: 'Accept all',
        refuse_all: 'Refuse all',
        save_choices: 'Save my choices',
        manage: 'Manage cookies',
      },
      disruptions: {
        banner_title_one: '1 delayed or cancelled train',
        banner_title_other: '{{count}} delayed or cancelled trains',
        banner_title: '{{count}} delayed/cancelled train(s)',
        major: 'major',
        minor: 'minor',
        unknown_label: 'Disruption',
        row_tooltip: 'This train is affected by a disruption',
        effect: {
          no_service:           'Cancelled',
          significant_delays:   'Delayed',
          reduced_service:      'Reduced service',
          detour:               'Detour',
          modified_service:     'Modified service',
          additional_service:   'Extra train',
          stop_moved:           'Stop relocated',
          other_effect:         'Passenger info',
          unknown:              'Disruption'
        }
      },
      legal: {
        back: 'Back to home',
        updated: 'Last updated: May 2026',
        ml_title: 'Legal notice',
        ml_editor_title: 'Publisher',
        ml_editor_body: 'InfoTrainFluo is a passenger information tool developed by Alterdia on behalf of SNCF Voyageurs — Fluo Grand Est.\n\nSNCF Voyageurs — 2, place aux Étoiles — CS 70001 — 93633 La Plaine Saint-Denis Cedex — France\nSociété anonyme — Share capital: €100,000,000 — SIREN: 412 280 737 — RCS Bobigny',
        ml_host_title: 'Hosting',
        ml_host_body: 'OVH SAS — 2 rue Kellermann — 59100 Roubaix — France',
        ml_data_title: 'Data sources',
        ml_data_body: 'Schedule and traffic data are provided by the public SNCF APIs (Navitia, GTFS-RT, SIRI) available through SNCF Open Data (opendata.sncf.com). This data is indicative; the publisher assumes no liability for inaccuracies.',
        ml_liability_title: 'Liability',
        ml_liability_body: "The publisher endeavours to ensure accuracy but cannot guarantee completeness or real-time updates. In case of doubt, station displays take precedence. Use of this service is at the user's own risk.",
        pc_title: 'Privacy policy',
        pc_intro: 'InfoTrainFluo collects minimal personal data, solely to ensure the proper operation of the service. No data is sold or transmitted to third parties for commercial purposes.',
        pc_cookies_title: 'Cookies and local storage',
        pc_cookies_body: '• Necessary cookies: storing consent and language preference. Duration: 1 year.\n• Preference cookies: your favourite stations and daily commute, stored locally on your device. Duration: 1 year. Can be disabled via the cookie banner.\n• Analytics cookies (PostHog): anonymous usage statistics, no personal identifiers. Enabled only after explicit consent.',
        pc_rights_title: 'Your rights (GDPR)',
        pc_rights_body: 'Under the General Data Protection Regulation (EU 2016/679), you have the right to access, rectify, erase, and object to your personal data. To exercise these rights, contact us by e-mail.',
        pc_contact_title: 'DPO contact',
        pc_contact_body: 'For any question regarding the protection of your personal data, contact the Data Protection Officer of SNCF Voyageurs: dpo@sncf.fr',
        cgu_title: 'Terms of Use',
        cgu_object_title: 'Purpose',
        cgu_object_body: 'InfoTrainFluo is a passenger information tool for the general public, providing real-time schedules and traffic information for Fluo Grand Est trains operated by SNCF Voyageurs.',
        cgu_access_title: 'Access to the service',
        cgu_access_body: 'Access to the service is free and does not require account creation. Users agree to use the service in accordance with these Terms of Use and applicable law.',
        cgu_ip_title: 'Intellectual property',
        cgu_ip_body: 'All elements of this website (texts, logos, trademarks, visuals) are protected by intellectual property law. The SNCF brand, the Fluo logo and associated visuals are the exclusive property of SNCF Voyageurs. Any reproduction is prohibited without prior authorisation.',
        cgu_liability_title: 'Limitation of liability',
        cgu_liability_body: 'Timetable information is provided for guidance only via SNCF open data. The publisher disclaims all liability for inaccuracies, update delays, or service interruptions. Station displays remain the official reference.'
      }
    }
  },
  de: {
    translation: {
      brand: { tagline: 'von SNCF Voyageurs • Echtzeit-Fahrplan' },
      nav: { home: 'Start', board: 'Fahrplan nach Bahnhof', commute: 'Mein täglicher Pendelweg', info_fluo: 'Alle Fluo Infos', lines: 'Hauptlinien' },
      hero: {
        live_badge: 'Echtzeitdaten • SNCF Open Data • Navitia',
        title_part1: 'Echtzeit-Informationen zu den',
        title_highlight: 'Fluo-Züge',
        title_part2: 'in Grand Est.',
        subtitle: 'von SNCF Voyageurs',
        description: 'Echtzeit-Fahrpläne, Verkehrsinformationen, vollständige Routen und Zugzusammensetzung für alle Bahnhöfe in Grand Est. Wählen Sie Ihren Bahnhof und speichern Sie Ihre Favoriten.',
        feature_realtime: 'Echtzeit-Fahrpläne',
        feature_platforms: 'Gleise und Bahnsteige',
        feature_route: 'Vollständige Route',
        feature_composition: 'Zugzusammensetzung'
      },
      mobility: {
        title: 'Fluo Grand Est, Ihre Mobilität jeden Tag!',
        text: 'Fluo vereint sämtliche Mobilitätslösungen in Grand Est, um den täglichen Verkehr in der ganzen Region zu erleichtern. Ein vernetztes, zugängliches Netz für alle!',
        stat_trains_prefix: 'fast',
        stat_trains: 'Züge / Tag',
        stat_buses: 'Busse / Tag',
        stat_stations: 'Bahnhöfe',
        stat_bikes: 'Fahrräder',
        stat_bikes_sub: 'an 52 Bahnhöfen',
        more: 'Mehr erfahren',
      },
      lines: { eyebrow: 'Fluo Grand Est Netz', title: 'Hauptstrecken', sublabel: 'Fluo Grand Est' },
      opendata: { eyebrow: 'Open Data', title: 'Mit SNCF / Navitia Open Data erstellt', text: 'Diese Oberfläche nutzt öffentliche APIs (Navitia, SIRI, GTFS-RT). Die Daten sind indikativ — bitte beachten Sie immer die Anzeigen am Bahnhof.' },
      campaign: { sidebar_title: 'Fluo-Kommunikation' },
      picker: {
        placeholder: 'Bahnhof wählen (Strasbourg, Metz, Nancy...)',
        button: 'Suchen',
        no_match: 'Kein Bahnhof entspricht „{{q}}"',
        empty: 'Bahnhofsnamen eingeben',
        kbd_hint: '↑↓ navigieren • ⏎ auswählen',
        navitia_search: 'Navitia-Suche',
        popular_count: '{{count}} Bahnhöfe in Grand Est',
        popular_title: 'Beliebte Bahnhöfe',
        favorites_title: 'Meine Lieblingsbahnhöfe',
        another_station: 'Anderen Bahnhof wählen'
      },
      board: {
        station_eyebrow: 'Bahnhof',
        favorite: 'Zu Favoriten',
        refresh: 'Aktualisieren',
        tab_dep: 'Abfahrten',
        tab_arr: 'Ankünfte',
        source_live: 'Quelle: SNCF Open Data • Navitia — Echtzeit',
        source_piv:  'Quelle: SNCF PIV — Echtzeit',
        source_demo: 'Quelle: Demo (mock)',
        loading: 'Daten werden geladen…',
        empty_dep: 'Keine bevorstehenden Abfahrten für diesen Bahnhof.',
        empty_arr: 'Keine bevorstehenden Ankünfte für diesen Bahnhof.',
        col_time: 'Zeit',
        col_train: 'Zug',
        col_destination: 'Ziel',
        col_origin: 'Ankommend von',
        col_coaches: 'Wagen',
        col_seats: 'Sitzplätze',
        col_platform: 'Gleis',
        col_status: 'Status',
        platform_label: 'Gleis',
        status_ontime: 'Pünktlich',
        status_delayed: 'Verspätet',
        status_cancelled: 'Ausgefallen',
        view_route: 'Route anzeigen',
        see_detail: 'Detail',
        disclaimer: 'Zeiten sind indikativ und können sich in Echtzeit ändern. Bitte beachten Sie die Anzeigen am Bahnhof.',
        demo_banner: 'Demo-Modus — simulierte Daten.',
        reconnect_banner: 'Verbindung zu Navitia wird wiederhergestellt… (letzte Daten weiter angezeigt)'
      },
      search_dialog: { title: 'Bahnhof suchen', text: 'Wählen Sie einen Bahnhof, um Echtzeit-Abfahrten und -Ankünfte anzuzeigen.' },
      train: {
        crumb: 'Zugdetails',
        train_label: 'Zug',
        vehicle_train: 'Zug',
        vehicle_bus: 'Bus',
        tab_route: 'Route',
        tab_map: 'Karte',
        tab_composition: 'Zusammensetzung',
        real_data_badge: 'ECHTZEITDATEN',
        source_navitia: 'Quelle: Navitia / SNCF Open Data',
        stops_count: '{{count}} Halte',
        loading_route: 'Route wird geladen…',
        no_stops: 'Keine Halte für diesen Zug gefunden.',
        comp_unavailable_title: 'Zusammensetzung nicht verfügbar',
        comp_unavailable_text: 'Das rollende Material für Zug {{number}} ist nicht in unserer Datenbank. Diese Information ist über die öffentliche SNCF-API nicht verfügbar — sie erfordert Zugriff auf den internen Feed von SNCF Voyageurs.',
        comp_disclaimer_title: 'Indikative Daten',
        comp_disclaimer_text: 'Der Referenzdatensatz „Theoretische Zusammensetzung" des rollenden Materials ist von SNCF Voyageurs nicht öffentlich zugänglich. Die folgenden Informationen sind eine indikative Darstellung (Mock), bis der autorisierte Zugang zum internen Feed gewährt wird.',
        coaches: 'Wagen',
        seats: 'Sitzplätze',
        material: 'Rollmaterial',
        configuration: 'Konfiguration',
        head_label: 'KOPF',
        direction: 'FAHRTRICHTUNG',
        legend_pmr: 'Barrierefreier Zugang',
        legend_bike: 'Fahrräder',
        legend_class: 'Klasse',
        legend_occupancy: 'Voraussichtliche Auslastung',
        coach_num: 'Nr. {{n}}',
        coach_seats: '{{n}} Plätze',
        map_sources: 'Quellen: OpenStreetMap + Navitia (SNCF Open Data)',
        map_no_coords: 'Geografische Koordinaten für diesen Zug nicht verfügbar.',
        map_legend_endpoints: 'Anfang / Ende',
        map_legend_stops: '{{count}} Zwischenhalte',
        map_legend_status_on_time: 'Pünktlich',
        map_legend_status_delayed: 'Verspätet',
        map_legend_status_cancelled: 'Ausgefallen',
        map_train_live: 'Geschätzte Position',
        map_train_position: 'Geschätzte Zugposition',
        map_position_disclaimer: 'Lineare Interpolation zwischen zwei Halten (Genauigkeit ±1 km). Nicht verfügbar für ausgefallene Züge.',
        map_locate_me: 'Mein Standort',
        map_you_are_here: 'Sie sind hier',
        map_geoloc_denied: 'Standortberechtigung verweigert.',
        map_geoloc_failed: 'Standort konnte nicht ermittelt werden.',
        map_geoloc_unsupported: 'Standort wird vom Browser nicht unterstützt.',
        map_attribution: 'Kartenmaterial: © OpenStreetMap contributors'
      },
      composition: {
        seats_unavailable: 'Information nicht verfügbar'
      },
      accessibility: {
        title:      'Barrierefreiheit',
        standard:   'Standardansicht',
        dyslexia:   'Legasthenie-Modus',
        lowvision:  'Sehbehinderung-Modus',
        persist:    'Meine Wahl speichern',
      },
      footer: {
        text: 'Echtzeit-Fahrplan der Fluo-Züge in Grand Est von SNCF Voyageurs. Echtzeit-Reiseinformationen über die SNCF Open Data (Navitia, SIRI, GTFS-RT): Fahrpläne, Gleise, Störungen.',
        nav_title: 'Navigation',
        admin_link: 'Admin-Bereich',
        legal_title: 'Rechtliches',
        legal_terms: 'Impressum',
        legal_privacy: 'Datenschutz',
        legal_cgu: 'AGB',
        copyright: '© {{year}} SNCF Voyageurs — Fluo Grand Est. Vervielfältigung verboten, alle Rechte vorbehalten.',
        sources: 'Daten: SNCF Open Data • Navitia • GTFS-RT'
      },
      lang: { label: 'Sprache' },
      share: {
        title: 'Teilen / Erinnern',
        title_prefix: 'Grand Est Zuginfo',
        whatsapp: 'Per WhatsApp senden',
        sms: 'Per SMS senden',
        copy: 'Nachricht kopieren',
        copied: 'Nachricht in Zwischenablage kopiert',
        copy_failed: 'Kopieren fehlgeschlagen',
        notify_10: 'Mich 10 Min. vorher erinnern',
        notify_scheduled: 'Erinnerung in {{mins}} Min. geplant',
        notify_unsupported: 'Benachrichtigungen werden nicht unterstützt',
        notify_denied: 'Benachrichtigungen abgelehnt',
        notify_too_late: 'Zeit bereits vorbei oder zu nah (< 10 Min.)',
        dep_at: 'Abfahrt um',
        arr_at: 'Ankunft um',
        arr_expected: 'Voraussichtliche Ankunft',
        notif_body_dep: 'Abfahrt {{time}} → {{dest}} (Gleis {{platform}})',
        notif_body_arr: 'Ankunft {{time}} in {{station}} aus {{origin}} (Gleis {{platform}})'
      },
      commute: {
        eyebrow: 'Mein täglicher Pendelweg',
        title: 'Speichern Sie Ihre Lieblingsverbindung und erstellen Sie Ihre eigenen Anzeigetafeln',
        from: 'Von',
        to: 'Nach',
        from_placeholder: 'Startbahnhof',
        to_placeholder: 'Zielbahnhof',
        save: 'Speichern',
        swap: 'Tauschen',
        edit: 'Ändern',
        delete: 'Löschen',
        next_n: 'Nächste {{n}} Direktzüge',
        empty: 'Kein Direktzug für diese Strecke in der nächsten Stunde.',
        seats_short: 'Pl.',
        mode_label: 'Modus',
        mode_next: 'Nächste Züge',
        mode_custom: 'Eigene Zeiten',
        from_time_label: 'Ab',
        window_3h: '(3-h-Fenster)',
        return_label: 'Rückfahrt',
        return_from_time: 'Rückfahrt ab',
        return_section: 'Rückfahrt',
        custom_window_title: 'ab {{time}} — 3-h-Fenster',
        save_settings: 'Einstellungen speichern',
        cookies_needed: 'Um Ihren Pendelweg auf diesem Gerät zu speichern, akzeptieren Sie die funktionalen Cookies (Banner unten auf der Seite oder „Cookies verwalten" im Footer). Es werden keine Daten an Dritte weitergegeben.',
        count_label: '{{n}} Züge'
      },
      wa_channel: {
        label: 'Mehr Infos auf unserem WhatsApp-Kanal',
        tooltip: 'Fluo Grand Est WhatsApp-Kanal öffnen — Echtzeitinfos zu Störungen Metz ↔ Thionville ↔ Luxemburg'
      },
      export: {
        pdf: 'PDF exportieren',
        generated_at: 'Erstellt am',
        section_outbound: 'Hinfahrt',
        section_return: 'Rückfahrt',
        footer_text: 'Live-Anzeigetafel der Fluo Grand Est Züge von SNCF Voyageurs. Echtzeit-Reiseinformationen über die SNCF Open Data (Navitia, SIRI, GTFS-RT): Fahrpläne, Gleise, Störungen.',
        footer_copyright: '© 2026 SNCF Voyageurs — Fluo Grand Est. Alle Rechte vorbehalten.'
      },
      tableau: {
        empty_title: 'Wählen Sie einen Bahnhof, um den Fahrplan anzuzeigen',
        empty_text: 'Geben Sie einen Bahnhofsnamen ein oder wählen Sie einen aus der Liste, um Abfahrten und Ankünfte in Echtzeit zu sehen.'
      },
      cookies: {
        title: 'Browser-Einstellungen',
        intro_v2: 'Fluo Grand Est verwendet Cookies und den lokalen Speicher Ihres Browsers. Sie können jede Kategorie einzeln aktivieren. Keine Werbe-Cookies.',
        cat_necessary: 'Unbedingt erforderlich',
        cat_necessary_desc: 'Notwendig für die Funktion der Seite (Ihre Zustimmungsauswahl speichern, Sprache). Kann nicht deaktiviert werden.',
        cat_preferences: 'Präferenzen',
        cat_preferences_desc: 'Speichert Ihre Lieblingsbahnhöfe und Ihren täglichen Pendelweg auf diesem Gerät. Keine Daten an Dritte.',
        cat_analytics: 'Reichweitenmessung',
        cat_analytics_desc: 'Anonyme Nutzungsstatistiken über PostHog zur Verbesserung der App. Keine Werbung, kein Datenweiterverkauf.',
        no_tracking_v2: 'Sie können Ihre Auswahl jederzeit über „Cookies verwalten" im Footer ändern. Ablehnen hat keinen Einfluss auf den Fahrplan-Zugriff.',
        accept_all: 'Alle akzeptieren',
        refuse_all: 'Alle ablehnen',
        save_choices: 'Auswahl speichern',
        manage: 'Cookies verwalten',
      },
      disruptions: {
        banner_title_one: '1 verspäteter oder gestrichener Zug',
        banner_title_other: '{{count}} verspätete oder gestrichene Züge',
        banner_title: '{{count}} verspätete/gestrichene Züge',
        major: 'gross',
        minor: 'klein',
        unknown_label: 'Störung',
        row_tooltip: 'Dieser Zug ist von einer Störung betroffen',
        effect: {
          no_service:           'Zugausfall',
          significant_delays:   'Zug verspätet',
          reduced_service:      'Eingeschränkter Verkehr',
          detour:               'Umleitung',
          modified_service:     'Geänderter Verkehr',
          additional_service:   'Zusatzzug',
          stop_moved:           'Halt verlegt',
          other_effect:         'Fahrgastinfo',
          unknown:              'Störung'
        }
      },
      legal: {
        back: 'Zurück zur Startseite',
        updated: 'Zuletzt aktualisiert: Mai 2026',
        ml_title: 'Impressum',
        ml_editor_title: 'Herausgeber',
        ml_editor_body: 'InfoTrainFluo ist ein Fahrgastinformationswerkzeug, das von Alterdia im Auftrag von SNCF Voyageurs — Fluo Grand Est entwickelt wurde.\n\nSNCF Voyageurs — 2, place aux Étoiles — CS 70001 — 93633 La Plaine Saint-Denis Cedex — Frankreich\nAktiengesellschaft — Stammkapital: 100.000.000 € — SIREN: 412 280 737 — RCS Bobigny',
        ml_host_title: 'Hosting',
        ml_host_body: 'OVH SAS — 2 rue Kellermann — 59100 Roubaix — Frankreich',
        ml_data_title: 'Verwendete Daten',
        ml_data_body: 'Fahrplan- und Verkehrsdaten stammen aus den öffentlichen SNCF-APIs (Navitia, GTFS-RT, SIRI), zugänglich über SNCF Open Data (opendata.sncf.com). Die Daten sind indikativ; der Herausgeber übernimmt keine Haftung für Ungenauigkeiten.',
        ml_liability_title: 'Haftungsausschluss',
        ml_liability_body: 'Der Herausgeber bemüht sich um Genauigkeit, kann jedoch weder Vollständigkeit noch Echtzeit-Aktualisierung garantieren. Im Zweifelsfall haben die Anzeigen am Bahnhof Vorrang. Die Nutzung erfolgt auf eigene Verantwortung des Nutzers.',
        pc_title: 'Datenschutzerklärung',
        pc_intro: 'InfoTrainFluo erhebt nur minimale personenbezogene Daten, ausschließlich um den Betrieb des Dienstes zu gewährleisten. Es werden keine Daten zu kommerziellen Zwecken verkauft oder an Dritte weitergegeben.',
        pc_cookies_title: 'Cookies und lokaler Speicher',
        pc_cookies_body: '• Notwendige Cookies: Speicherung von Einwilligung und Spracheinstellung. Dauer: 1 Jahr.\n• Präferenz-Cookies: Ihre Lieblingsbahnhöfe und Ihr täglicher Pendelweg, lokal auf Ihrem Gerät gespeichert. Dauer: 1 Jahr. Über das Cookie-Banner deaktivierbar.\n• Analyse-Cookies (PostHog): anonyme Nutzungsstatistiken, keine persönlichen Identifikatoren. Nur nach ausdrücklicher Einwilligung aktiviert.',
        pc_rights_title: 'Ihre Rechte (DSGVO)',
        pc_rights_body: 'Gemäß der Datenschutz-Grundverordnung (EU 2016/679) haben Sie das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch bezüglich Ihrer personenbezogenen Daten. Zur Ausübung dieser Rechte kontaktieren Sie uns per E-Mail.',
        pc_contact_title: 'Datenschutzbeauftragter',
        pc_contact_body: 'Für Fragen zum Schutz Ihrer personenbezogenen Daten wenden Sie sich an den Datenschutzbeauftragten von SNCF Voyageurs: dpo@sncf.fr',
        cgu_title: 'Nutzungsbedingungen',
        cgu_object_title: 'Zweck',
        cgu_object_body: 'InfoTrainFluo ist ein Fahrgastinformationswerkzeug für die Allgemeinheit, das Echtzeit-Fahrpläne und Verkehrsinformationen für Fluo Grand Est Züge von SNCF Voyageurs bereitstellt.',
        cgu_access_title: 'Zugang zum Dienst',
        cgu_access_body: 'Der Zugang ist kostenlos und erfordert keine Kontoerstellung. Die Nutzer verpflichten sich, den Dienst gemäß diesen Nutzungsbedingungen und den geltenden Rechtsvorschriften zu nutzen.',
        cgu_ip_title: 'Geistiges Eigentum',
        cgu_ip_body: 'Alle Elemente dieser Website (Texte, Logos, Marken, Bilder) sind durch das Urheberrecht geschützt. Die Marke SNCF, das Fluo-Logo und die damit verbundenen Bilder sind ausschließliches Eigentum von SNCF Voyageurs. Jede Vervielfältigung ist ohne vorherige Genehmigung verboten.',
        cgu_liability_title: 'Haftungsbeschränkung',
        cgu_liability_body: 'Fahrplaninformationen werden nur als Anhaltspunkt über offene SNCF-Daten bereitgestellt. Der Herausgeber übernimmt keine Haftung für Ungenauigkeiten, Verzögerungen oder Dienstunterbrechungen. Die Anzeigen am Bahnhof bleiben die offizielle Referenz.'
      }
    }
  },
  lb: {
    translation: {
      brand: { tagline: 'vu SNCF Voyageurs • Live Fahrplang' },
      nav: { home: 'Startsäit', board: 'Fahrplang pro Gare', commute: 'Mäin deeglechen Trajet', info_fluo: 'All Fluo-Info', lines: 'Haaptlinnen' },
      hero: {
        live_badge: 'Echtzäitdaten • SNCF Open Data • Navitia',
        title_part1: 'Echtzäit-Infoen vun de',
        title_highlight: 'Fluo-Zich',
        title_part2: 'a Grand Est.',
        subtitle: 'vu SNCF Voyageurs',
        description: 'Echtzäit-Horairen a Verkéiersinfo, Gleisnummer an Zesummesetzung vun all Zuch fir all Gare am Grand Est. Wielt Är Lieblingstrajeten an erstellt Är eege Fahrplangtafelen.',
        feature_realtime: 'Echtzäit-Horairen',
        feature_platforms: 'Glaiser a Quaien',
        feature_route: 'Komplette Wee',
        feature_composition: 'Zesummesetzung vum Zuch'
      },
      mobility: {
        title: 'Fluo Grand Est, Är deeglech Mobilitéit!',
        text: 'Fluo versammelt all d\'Mobilitéitsléisunge vum Grand Est fir déi deeglech Trajeten an der ganzer Regioun ze erliichteren. E vernetzten, zougänglechen Netzwierk, dee fir jiddereen geduecht ass!',
        stat_trains_prefix: 'bal',
        stat_trains: 'Zich / Dag',
        stat_buses: 'Bussen / Dag',
        stat_stations: 'Garen',
        stat_bikes: 'Vëloen',
        stat_bikes_sub: 'an 52 Garen',
        more: 'Méi Info',
      },
      lines: { eyebrow: 'Fluo Grand Est Reseau', title: 'Haaptlinnen', sublabel: 'Fluo Grand Est' },
      opendata: { eyebrow: 'Open Data', title: 'Mat SNCF / Navitia Open Data gebaut', text: 'Dës Plattform notzt ëffentlech APIen (Navitia, SIRI, GTFS-RT). Daten sinn indikativ — bekuckt och d\'Affichage an der Gare.' },
      campaign: { sidebar_title: 'Fluo Kommunikatioun' },
      picker: {
        placeholder: 'Gare auswielen (Strasbourg, Metz, Nancy...)',
        button: 'Sichen',
        no_match: 'Keng Gare entsprécht « {{q}} »',
        empty: 'Schreift de Numm vun enger Gare',
        kbd_hint: '↑↓ navigéieren • ⏎ auswielen',
        navitia_search: 'Navitia Sich',
        popular_count: '{{count}} Garen am Grand Est',
        popular_title: 'Bekannt Garen',
        favorites_title: 'Meng Favorit-Garen',
        another_station: 'Eng aner Gare wielen'
      },
      board: {
        station_eyebrow: 'Gare',
        favorite: 'Zu Favoritte bäisetzen',
        refresh: 'Aktualiséieren',
        tab_dep: 'Départen',
        tab_arr: 'Arrivéeën',
        source_live: 'Quell: SNCF Open Data • Navitia — Echtzäit',
        source_piv:  'Quell: SNCF PIV — Echtzäit',
        source_demo: 'Quell: Demo (mock)',
        loading: 'Daten gi gelueden…',
        empty_dep: 'Keng Départen virgesinn fir dës Gare.',
        empty_arr: 'Keng Arrivéeën virgesinn fir dës Gare.',
        col_time: 'Zäit',
        col_train: 'Zuch',
        col_destination: 'Destinatioun',
        col_origin: 'Hierkonft',
        col_coaches: 'Wagonen',
        col_seats: 'Sëtzplazen',
        col_platform: 'Glaisnummer',
        col_status: 'Status',
        platform_label: 'Glais',
        status_ontime: 'Pünktlech',
        status_delayed: 'Spéit',
        status_cancelled: 'Ausgefall',
        view_route: 'Wee weisen',
        see_detail: 'Detailer',
        disclaimer: 'D\'Zäiten si indikativ a kënnen sech an Echtzäit änneren. Bekuckt d\'Affichage an der Gare.',
        demo_banner: 'Demo-Modus — simuléiert Daten.',
        reconnect_banner: 'Verbindung mat Navitia gëtt opgeholl… (lescht Daten gi weiderhin gewisen)'
      },
      search_dialog: { title: 'No enger Gare sichen', text: 'Wielt eng Gare fir live Départen an Arrivéeën ze gesinn.' },
      train: {
        crumb: 'Zuch-Detailer',
        train_label: 'Zuch',
        vehicle_train: 'Zuch',
        vehicle_bus: 'Bus',
        tab_route: 'Wee',
        tab_map: 'Kaart',
        tab_composition: 'Zesummesetzung',
        real_data_badge: 'LIVE DATEN',
        source_navitia: 'Quell: Navitia / SNCF Open Data',
        stops_count: '{{count}} Stoppen',
        loading_route: 'Wee gëtt gelueden…',
        no_stops: 'Keng Stoppen fonnt fir dëse Zuch.',
        comp_unavailable_title: 'Zesummesetzung net verfügbar',
        comp_unavailable_text: 'D\'Material fir den Zuch {{number}} ass net an eiser Datebank. Dës Informatioun ass net iwwer déi ëffentlech SNCF-API — si brauch Zougang zum internen Feed vu SNCF Voyageurs.',
        comp_disclaimer_title: 'Indikativ Donnéeën',
        comp_disclaimer_text: 'De Referenzdatesaz „Theoretesch Zesummesetzung" vum rullende Material ass net ëffentlech vu SNCF Voyageurs verfügbar. D\'Informatiounen hei ënnen sinn eng indikativ Duerstellung (Mock), bis en autoriséierten Zougang zum internen Feed kritt gëtt.',
        coaches: 'Wagonen',
        seats: 'Sëtzplazen',
        material: 'Rullend Material',
        configuration: 'Konfiguratioun',
        head_label: 'KAP',
        direction: 'FUERRICHTUNG',
        legend_pmr: 'Mobilitéitshëllef',
        legend_bike: 'Vëloen',
        legend_class: 'Klass',
        legend_occupancy: 'Indikativ Auslaaschtung',
        coach_num: 'Nr {{n}}',
        coach_seats: '{{n}} Pl.',
        map_sources: 'Quellen: OpenStreetMap + Navitia (SNCF Open Data)',
        map_no_coords: 'Geographesch Koordinate fir dëse Zuch net verfügbar.',
        map_legend_endpoints: 'Ufank / Enn',
        map_legend_stops: '{{count}} Zwëschenstoppen',
        map_legend_status_on_time: 'Pünktlech',
        map_legend_status_delayed: 'Verspéidet',
        map_legend_status_cancelled: 'Ofgesot',
        map_train_live: 'Geschätzte Positioun',
        map_train_position: 'Geschätzte Zuchpositioun',
        map_position_disclaimer: 'Lineare Interpolatioun tëscht zwou Stoppen (Genauegkeet ±1 km). Net verfügbar fir ofgesote Zich.',
        map_locate_me: 'Meng Positioun',
        map_you_are_here: 'Dir sidd hei',
        map_geoloc_denied: 'Geoposition verweigert.',
        map_geoloc_failed: 'Är Positioun konnt net fonnt ginn.',
        map_geoloc_unsupported: 'Geolocatioun net ënnerstëtzt.',
        map_attribution: 'Kaartmaterial: © OpenStreetMap contributors'
      },
      composition: {
        seats_unavailable: 'Informatioun net verfügbar'
      },
      accessibility: {
        title:      'Accessibilitéit',
        standard:   'Standard Affichage',
        dyslexia:   'Dyslexie-Modus',
        lowvision:  'Schwaachsiichteg-Modus',
        persist:    'Meng Wiel späicheren',
      },
      footer: {
        text: 'Live Fahrplang vun de Fluo-Zich am Grand Est vu SNCF Voyageurs. Echtzäit-Reesinformatioune vun de SNCF Open Data (Navitia, SIRI, GTFS-RT): Horairen, Glaiser, Stéierungen.',
        nav_title: 'Navigatioun',
        admin_link: 'Admin-Beräich',
        legal_title: 'Juristesches',
        legal_terms: 'Impressum',
        legal_privacy: 'Dateschutz',
        legal_cgu: 'AGB',
        copyright: '© {{year}} SNCF Voyageurs — Fluo Grand Est. Reproduktioun verbueden, all Rechter reservéiert.',
        sources: 'Daten: SNCF Open Data • Navitia • GTFS-RT'
      },
      lang: { label: 'Sprooch' },
      share: {
        title: 'Deelen / Erënneren',
        title_prefix: 'Grand Est Zuchinfo',
        whatsapp: 'Iwwer WhatsApp schécken',
        sms: 'Iwwer SMS schécken',
        copy: 'Message kopéieren',
        copied: 'Message an d\'Zwëschenofloss kopéiert',
        copy_failed: 'Konnt net kopéieren',
        notify_10: 'Mech 10 Min. virdrun erënneren',
        notify_scheduled: 'Erënnerung an {{mins}} Min. geplangt',
        notify_unsupported: 'Notifikatiounen net ënnerstëtzt',
        notify_denied: 'Notifikatiounen ofgeleent',
        notify_too_late: 'Zäit ass schonn eriwwer oder ze no (< 10 Min.)',
        dep_at: 'Départ um',
        arr_at: 'Arrivée um',
        arr_expected: 'Erwaart Arrivée',
        notif_body_dep: 'Départ {{time}} → {{dest}} (Glais {{platform}})',
        notif_body_arr: 'Arrivée {{time}} zu {{station}} vu {{origin}} (Glais {{platform}})'
      },
      commute: {
        eyebrow: 'Mäin deeglechen Trajet',
        title: 'Späichert Är Lieblingstrajet an erstellt Är eege Fahrplangtafelen',
        from: 'Vu',
        to: 'Op',
        from_placeholder: 'Departgare',
        to_placeholder: 'Arrivéesgare',
        save: 'Späicheren',
        swap: 'Tauschen',
        edit: 'Änneren',
        delete: 'Läschen',
        next_n: 'Nächst {{n}} direkt Zich',
        empty: 'Keen direkten Zuch fir dëst Trajet an der nächster Stonn.',
        seats_short: 'Plazen',
        mode_label: 'Modus',
        mode_next: 'Nächst Zich',
        mode_custom: 'Eege Zäiten',
        from_time_label: 'Vu',
        window_3h: '(3-Stonnen-Plage)',
        return_label: 'Retour',
        return_from_time: 'Retour vu',
        return_section: 'Retour',
        custom_window_title: 'vu {{time}} — 3-Stonnen-Plage',
        save_settings: 'Astellungen späicheren',
        cookies_needed: 'Fir Äre Trajet op dësem Apparat ze späicheren, akzeptéiert d\'funktionell Cookien (Bannéiere ënne op der Säit oder „Cookien verwalten" am Footer). Keng Donnéeën ginn un Drëtter weidergeleet.',
        count_label: '{{n}} Zich'
      },
      wa_channel: {
        label: 'Méi Infoen op eisem WhatsApp-Kanal',
        tooltip: 'Fluo Grand Est WhatsApp-Kanal opmaachen — Echtzäit-Infoen iwwer Stéierungen Metz ↔ Thionville ↔ Lëtzebuerg'
      },
      export: {
        pdf: 'PDF exportéieren',
        generated_at: 'Erstallt den'
      },
      tableau: {
        empty_title: 'Wielt eng Gare fir den Tableau ze weisen',
        empty_text: 'Schreift den Numm vun enger Gare oder wielt eng aus der Lëscht fir live Départen an Arrivéeën ze gesinn.'
      },
      cookies: {
        title: 'Browser-Astellungen',
        intro_v2: 'Fluo Grand Est benotzt Cookien an de lokale Späicher vun Ärem Browser. Dir kënnt all Kategorie eenzel aktivéieren. Keng Reklamm-Cookien.',
        cat_necessary: 'Strikt néideg',
        cat_necessary_desc: 'Néideg fir d\'Funktioun vum Site (Är Zoustëmmung späicheren, Sprooch). Kann net deaktivéiert ginn.',
        cat_preferences: 'Preferenzen',
        cat_preferences_desc: 'Späichert Är Lieblingsgaren an Äre deegleche Trajet op dësem Apparat. Keng Donnéeën un Drëtter.',
        cat_analytics: 'Reichwäitenmessung',
        cat_analytics_desc: 'Anonym Notzungsstatistiken iwwer PostHog fir d\'App ze verbesseren. Keng Reklamm, kee Wiederverkaaf vun Donnéeën.',
        no_tracking_v2: 'Dir kënnt Är Choix zu all Moment iwwer „Cookien verwalten" am Footer änneren. Refuséieren ännert näischt um Zougang zum Fahrplang.',
        accept_all: 'All akzeptéieren',
        refuse_all: 'All refuséieren',
        save_choices: 'Meng Choix späicheren',
        manage: 'Cookien verwalten',
      },
      disruptions: {
        banner_title_one: '1 verspéidete oder ofgesote Zuch',
        banner_title_other: '{{count}} verspéidete oder ofgesote Zich',
        banner_title: '{{count}} verspéidete/ofgesote Zich',
        major: 'grouss',
        minor: 'kleng',
        unknown_label: 'Stéierung',
        row_tooltip: 'Dëse Zuch ass vun enger Stéierung betraff',
        effect: {
          no_service:           'Annuléiert',
          significant_delays:   'Zuch a Verspéidung',
          reduced_service:      'Reduzéierte Service',
          detour:               'Ëmgangswee',
          modified_service:     'Geännerten Service',
          additional_service:   'Zousätzlechen Zuch',
          stop_moved:           'Arrêt verréckelt',
          other_effect:         'Passagéierinfo',
          unknown:              'Stéierung'
        }
      },
      legal: {
        back: "Zréck op d'Haaptsäit",
        updated: 'Lescht aktualiséiert: Mee 2026',
        ml_title: 'Impressum',
        ml_editor_title: 'Editeur',
        ml_editor_body: "InfoTrainFluo ass en Passagéier-Informatiounstool, deen vun Alterdia am Numm vu SNCF Voyageurs — Fluo Grand Est entwéckelt gouf.\n\nSNCF Voyageurs — 2, place aux Étoiles — CS 70001 — 93633 La Plaine Saint-Denis Cedex — Frankräich\nAktiegesellschaft — Stammkapital: 100.000.000 € — SIREN: 412 280 737 — RCS Bobigny",
        ml_host_title: 'Hebergement',
        ml_host_body: 'OVH SAS — 2 rue Kellermann — 59100 Roubaix — Frankräich',
        ml_data_title: 'Benotzt Donnéeën',
        ml_data_body: "D'Horairen a Verkéiersdaten kommen aus den ëffentleche SNCF-APIen (Navitia, GTFS-RT, SIRI), zougänglech iwwer SNCF Open Data (opendata.sncf.com). D'Daten sinn indikativ; den Editeur iwwerhëlt keng Haftung fir Ongenaiegkeeten.",
        ml_liability_title: "Haftungsausschléiss",
        ml_liability_body: "Den Editeur bemüht sech ëm Genauegkeet, kann awer weder Vollständegkeet nach Echtzäit-Aktualiséierung garantéieren. Am Zweifelsfall hunn d'Affichen an der Gare Virrang.",
        pc_title: 'Dateschutzpolitik',
        pc_intro: "InfoTrainFluo sammelt nëmmen e Minimum un perséinleche Donnéeën, ausschliisslech fir de richtege Betrieb vum Déngscht ze garantéieren. Keng Donnéeën gi fir kommerziell Zwecker verkaaft oder un Drëtter weiderginn.",
        pc_cookies_title: 'Cookien a lokale Späicher',
        pc_cookies_body: "• Néideg Cookien: Späicherung vum Consens a vun der Sproochastellung. Dauer: 1 Joer.\n• Preferenz-Cookien: Är Lieblingsgaren an Äre deeglechen Trajet, lokal op Ärem Apparat gespäichert. Dauer: 1 Joer. Iwwer de Cookie-Banner deaktivéierbar.\n• Analyse-Cookien (PostHog): anonym Notzungsstatistiken, keng perséinlech Identifikatoren. Nëmme no explizitem Consens aktivéiert.",
        pc_rights_title: 'Är Rechter (DSGVO)',
        pc_rights_body: "Entspriechend der Dateschutz-Grondverordnung (EU 2016/679) hutt Dir d'Recht op Auskonft, Berichtegung, Läschen an Widdersproch bezüglech Ärer perséinlecher Donnéeën. Fir dës Rechter auszezüben, kontaktéiert eis per E-Mail.",
        pc_contact_title: 'Dateschutzbeauftragten',
        pc_contact_body: 'Fir all Fro zum Schutz vun Äre perséinlechen Donnéeën, adresséiert Iech un den Dateschutzbeauftragten vu SNCF Voyageurs: dpo@sncf.fr',
        cgu_title: 'Notzungsbedingungen',
        cgu_object_title: 'Zweck',
        cgu_object_body: "InfoTrainFluo ass en Passagéier-Informatiounstool fir d'Allgemengheet, dat Echtzäit-Horairen an Verkéiersinformatioune fir Fluo Grand Est Zich vu SNCF Voyageurs ubitt.",
        cgu_access_title: 'Zougang zum Déngscht',
        cgu_access_body: "Den Zougang zum Déngscht ass gratis a braucht kee Kont. D'Benotzer verpflichten sech, den Déngscht am Aklang mat dëse Bedingungen an der gëlteger Gesetzgebung ze benotzen.",
        cgu_ip_title: 'Geeschtegt Eegendom',
        cgu_ip_body: "All Elementer vun dësem Site (Texter, Logoen, Marken, Biller) si vum Auteursdroit geschützt. D'Marke SNCF, de Fluo-Logo an déi verbonnen Biller sinn exklusivt Eegedom vu SNCF Voyageurs. All Reproduktioun ass ouni virherige Genehmegung verboten.",
        cgu_liability_title: 'Haftungsbeschrängung',
        cgu_liability_body: "Fahrplanginformatioune ginn nëmmen als Unhaltspunkt via SNCF Open Data geliwwert. Den Editeur iwwerhëlt keng Haftung fir Ongenaiegkeeten, Verspéidungen oder Dienstunterbriechungen. D'Affichen an der Gare bleiwen d'offiziell Referenz."
      }
    }
  }
};

const SUPPORTED_LANGS = ['fr', 'en', 'de', 'lb'];
const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
const initialLang = SUPPORTED_LANGS.includes(stored) ? stored : 'fr';

// Normalize legacy / unsupported values back to the resolved language
if (typeof window !== 'undefined' && stored !== initialLang) {
  try { localStorage.setItem(STORAGE_KEY, initialLang); } catch { /* noop */ }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'fr',
    interpolation: { escapeValue: false }
  });

i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem(STORAGE_KEY, lng); } catch { /* noop */ }
});

export default i18n;
